import React from "react";
import Frame from "../layout/Frame";
import Meta from "../layout/Meta";
import PulseList from "../blocks/Pulse";
import Invite from "../blocks/Invite";

const Pulse = () => (
  <Frame>
    <Meta title="Pulse" description="Field notes from the NTAC trading desk — quarterly reads on what's working and what's broken in the performance channels we run." />
    <section className="svc-hero">
      <div className="shell">
        <div className="crumb"><a href="/">Home</a><span className="sep">/</span>Pulse</div>
        <span className="tag tag--orange">PULSE</span>
        <h1 style={{ marginTop: "1.25rem" }}>Field notes from the trading desk.</h1>
        <p className="lede">
          We publish quarterly. No content marketing for the sake of it. Each note distils what is actually
          changing in the channels our team trades through every week.
        </p>
      </div>
    </section>
    <section className="band">
      <div className="shell">
        <PulseList />
      </div>
    </section>
    <Invite />
  </Frame>
);

export default Pulse;
